import { z } from "zod";
import { optionalSearch } from "./shared";

/** Post-auth return path (pathname + search), e.g. `/declare-dissent?runId=…`. */
export const loginSearchSchema = z.object({
  redirect: optionalSearch(z.string()),
});

export type LoginSearch = z.infer<typeof loginSearchSchema>;
